module.exports = __webpack_public_path__ + "static/media/diputados-selected.ddb73810.svg";